<div class="flex grow items-center date-search">
    <fieldset class="fields flex w-full lg:2/3 xl:1/2 relative group lg:max-w-sm">
        <legend class="sr-only" aria-label="Start and End Date">Start and End Date</legend>

        <div class="relative w-full">
            <label for="startDate" class="text-[9px] uppercase absolute top-[0.4rem] left-[1.2rem]">Start date</label>
            <input
                ref="startDateInput"
                id="startDate"
                name="startDate"
                type="date"
                v-model="datesStore.startDate"
                :min="minimumDate()"
                class="!rounded-r-lg border-r-0 focus:z-10 text-sm lg:text-base !pt-[1.2rem] lg:!pt-1 !pb-[0.5rem] !text-gray-600"
                @change="onDateChange('startDate', $event.target.value)"
            />
        </div>

        <div class="w-[1px] bg-slate-400"></div>

        <div class="relative w-full">
            <label for="endDate" class="text-[9px] uppercase absolute top-[0.4rem] left-[1.2rem]">End date</label>
            <input
                ref="endDateInput"
                id="endDate"
                name="endDate"
                type="date"
                v-model="datesStore.endDate"
                :min="minimumDate()"
                class="!rounded-l-lg border-l-0 text-sm lg:text-base !pt-[1.2rem] lg:!pt-1 !pb-[0.5rem] !text-gray-600"
                @change="onDateChange('endDate', $event.target.value)"
            />
        </div>
    </fieldset>
</div>
